Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnalytics = void 0;
var _react = require("react");
var _AnalyticsContext = require("../AnalyticsContext");
var _Events = require("./Events");
var _reactNative = require("react-native-web");
var useAnalytics = exports.useAnalytics = function useAnalytics() {
  var analyticsContext = (0, _react.useContext)(_AnalyticsContext.AnalyticsContext);
  var getTrackingURL = function getTrackingURL(pathname) {
    if (typeof pathname === 'undefined') return undefined;
    if (_reactNative.Platform.OS === 'web') {
      var _url = new URL(window.location.href);
      _url.pathname = pathname;
      return _url.href;
    }
    return "app://localhost".concat(pathname);
  };
  return {
    trackEvent: function trackEvent(props) {
      return analyticsContext.trackEvent(props);
    },
    trackingEvents: _Events.Events,
    getTrackingURL: getTrackingURL
  };
};